<template>
  <div class="pre-checkout-sidebar-login">
    <slot name="error"></slot>
    <div class="pre-checkout-sidebar-login-checkouttitle">
      Checkout
    </div>
    <div class="pre-checkout-sidebar-login-title">
      {{ t("pre.checkout.sign.in.title") }}
    </div>
    <form class="pre-checkout-sidebar-login-form" accept-charset="utf-8" method="post">
      <div class="form-group">
        <label class="customer-login-form-label sr-only" for="precheckout-login-email">Email</label>
        <input id="precheckout-login-email"
          v-model="email"
          class="form-control"
          name="email"
          placeholder="Το email σου"
          required
          type="email"
        >
      </div>
      <div class="form-group">
        <label class="customer-login-form-label sr-only" for="password">Password</label>
        <input id="password"
          ref="passwordInput"
          v-model="password"
          class="form-control dioptra-input-field password-class"
          name="password"
          placeholder="Κωδικός"
          required
          type="password"
        >
      </div>
      <div class="pre-checkout-sidebar-login-form-recover-password">
        <a href="/customer/recover_password" class="pre-checkout-sidebar-login-form-recover-password-url">
          <span v-html="t('pre.checkout.forgot.pass')"></span>
        </a>
      </div>
      <button class="pre-checkout-sidebar-body-form-button submit-btn" name="login" type="submit" value="login">
        <span>
          {{  t("pre.checkout.sign.in.title") }}
        </span>
      </button>
      <div class="d-flex-100 checkoutSocialLoginRow">
        <div class="full-width-line">
          <span class="line"></span>
          <span class="or">{{ t('login.or.text') }}</span>
          <span class="line"></span>
        </div>
        <div v-if="socialLoginEnabled" class="d-flex-100 customer-login-social">
          <div v-if="getFacebookLoginEnabled" class="d-flex col-12 justify-content-center align-content-center align-items-center socialLoginBtn" id="gLoginBtn">
            <a :href="'/customer/googleLogin'" class="d-flex-100 justify-content-center align-items-center align-content-center">{{ t('customer.login.google.label') }}</a>
          </div>
          <div v-if="getGoogleLoginEnabled" class="d-flex col-12 justify-content-center align-content-center align-items-center socialLoginBtn" id="fbLoginBtn">
            <a :href="'/customer/facebookLogin'" class="d-flex-100 justify-content-center align-items-center align-content-center">{{ t('customer.login.facebook.label') }}</a>
          </div>
        </div>
      </div>
    </form>
    <div class="pre-checkout-sidebar-login-actions">
      <div class="d-flex-100 pre-checkout-sidebar-login-actions-register">
        <span class="pre-checkout-sidebar-login-actions-register-text">
          {{ t("pre.checkout.no.account.register.title") }}
        </span>
        <button class="pre-checkout-sidebar-login-actions-register-button submit-btn"
          name="register_customer"
          value="register"
          @click="onRegisterClick"
        >
          <span>
            {{ t('pre.checkout.sign.up.title') }}
          </span>
        </button>
      </div>
      <div class="d-flex-100 pre-checkout-sidebar-login-actions-guest">
        <span class="pre-checkout-sidebar-login-actions-guest-text">
          {{ t("pre.checkout.faster.process.title")}}
        </span>
        <a :href="'/preview_order'" class="d-flex-100">
          <button class="pre-checkout-sidebar-login-actions-guest-button submit-btn"
            name="guest_customer"
            value="guest"
            @click="onGuestClick"
          >
            <span>{{ t('pre.checkout.sign.up.guest') }}</span>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PreCheckoutSidebarLogin',
  data () {
    return {
      email: '',
      password: '',
      passwordVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'getGoogleLoginEnabled',
      'getFacebookLoginEnabled'
    ]),
    socialLoginEnabled () {
      return this.getGoogleLoginEnabled || this.getFacebookLoginEnabled
    }
  },
  methods: {
    togglePasswordVisibility () {
      const passwordInput = this.$refs.passwordInput
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password'
      this.passwordVisible = !this.passwordVisible
    },
    onRegisterClick () {
      this.$emit('register-click')
    },
    onGuestClick () {
      this.$emit('guest')
    }
  }
}
</script>

<style lang="scss" scoped>

.form-control {
  border: 1px solid #1A1818;
  border-radius: 0;
  padding: 0.938rem;
  color: #1A1818;
}

// .pre-checkout-sidebar-login {
//   // padding-left: 40px;
//   // padding-right: 40px;
//   // padding-top:45px;
// }

.pre-checkout-sidebar-login-form-recover-password {
  margin-bottom: 1.25rem;
  width: 100%;
  @media screen and (max-width: 1199px){
    text-align: center
  }
}

.pre-checkout-sidebar-login-form-recover-password-url {
  font-size: 14px;
  font-weight: 400;
  color: #1A1818
}

.pre-checkout-sidebar-body-form-button {
  background-color: #1A1818;
  font-size: 1.063rem; //17px
  border-radius: 0;
  width: 100%;
  font-weight: 700
}

.pre-checkout-sidebar-login-title {
  margin-bottom: 0.938rem
}

.pre-checkout-sidebar-login-title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1A1818;
  @media screen and (max-width: 767px) {
    font-size: 19px;
  }
}


</style>
